"use client"

import { useEffect } from "react"
import { subscribeToPush } from "../lib/subscribe-push"
import { usePushSubscription } from "./use-push-subscription"

export const useEnsurePushSubscription = () => {
  const { subscription, setSubscription } = usePushSubscription()

  useEffect(() => {
    if (subscription !== null) return
    if (typeof window === "undefined") return
    if (typeof Notification === "undefined") return
    if (Notification.permission !== "granted") return
    void subscribeToPush().then(setSubscription).catch(() => {})
  }, [subscription])
}
